// extracted by mini-css-extract-plugin
export var section = "blog-module--section--1pcdB";
export var hero = "blog-module--hero--2iIdf";
export var subtitle = "blog-module--subtitle--1EWdV";
export var link = "blog-module--link--1nJBm";